import React from 'react';
import { Link } from 'react-router-dom';

const CpanelStatCard = ({ icon: Icon, label, value, hint, variant = 'brand', linkTo }) => {
  const card = (
    <div className={`card cpanel-stat-card cpanel-stat-card--${variant} h-100`}>
      <div className="card-body d-flex align-items-center py-5">
        <div className="symbol symbol-50px me-4">
          <span className="symbol-label">
            <Icon size={24} stroke={1.75} />
          </span>
        </div>
        <div>
          <div className="text-gray-500 fw-semibold fs-7 text-uppercase ls-1">{label}</div>
          <div className="fs-2hx fw-bold text-gray-800 lh-1">{value}</div>
          {hint ? <div className="text-muted fs-8 mt-1">{hint}</div> : null}
        </div>
      </div>
    </div>
  );

  if (!linkTo) return card;

  return (
    <Link to={linkTo} className="cpanel-stat-card-link text-decoration-none d-block h-100">
      {card}
    </Link>
  );
};

export default CpanelStatCard;
